import { ComponentProps, FC } from 'react';

import { CollectionTable } from './CollectionTable';
import { ICollectionTableProps, ICollectionTableQuery } from './interfaces';
import { renderGenericTable } from './Table';

export const getCollectionTableOfType = <
  D,
  S extends string,
  F extends string,
  SC,
  TQ extends ICollectionTableQuery<SC> = ICollectionTableQuery<SC>,
>() =>
  ((props: Omit<ICollectionTableProps<D, S, F, SC, TQ>, 'renderGenericTable'>) => (
    <CollectionTable
      {...(props as unknown as ComponentProps<typeof CollectionTable>)}
      renderGenericTable={renderGenericTable}
    />
  )) as FC<Omit<ICollectionTableProps<D, S, F, SC, TQ>, 'renderGenericTable'>>;
